module.exports = __webpack_public_path__ + "img/txt_7min.5678464f.svg";